(function () {
  "use strict";

  var root = document.querySelector("[data-beanited-brew-match]");
  if (!root) return;

  var enabled = root.dataset.enabled === "true";
  var coffeeUrl = root.dataset.coffeeUrl || "/collections/all";
  var content = root.querySelector("[data-bm-content]");
  var productIndexElement = document.querySelector("[data-bm-product-index]");
  var productIndex = [];
  try { productIndex = productIndexElement ? JSON.parse(productIndexElement.textContent).products || [] : []; } catch (error) { productIndex = []; }
  var previousFocus = null;
  var state = { drink: null, roast: null, profiles: [], step: 2 };
  var drinkMap = { "milk-based": "Milk", milk: "Milk", black: "Black", filter: "Filter", filtered: "Filter", decaf: "Decaf", decaff: "Decaf" };
  var roastOptions = ["Light", "Medium", "Dark"];
  var profileOptions = ["Chocolate & Nutty", "Caramel & Sweet", "Fruity", "Floral", "Spiced & Earthy", "Bold & Smoky"];

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (character) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[character];
    });
  }

  function browseLink() {
    return '<div class="bm__browse-wrap"><a class="bm__browse" href="' + escapeHtml(coffeeUrl) + '">LET ME CHOOSE</a></div>';
  }

  function progress(step) {
    return '<div aria-hidden="true" class="bm__progress">' + [1, 2, 3].map(function (position) {
      return '<span class="bm__progress-segment' + (position <= step ? ' is-active' : '') + '"></span>';
    }).join('') + '</div>';
  }

  function options(values, selected, name, multiple) {
    return '<div class="bm__options">' + values.map(function (value) {
      var pressed = multiple ? selected.indexOf(value) > -1 : selected === value;
      return '<button aria-pressed="' + pressed + '" class="bm__option" data-bm-option="' + name + '" data-bm-value="' + escapeHtml(value) + '" type="button">' + escapeHtml(value) + '</button>';
    }).join("") + "</div>";
  }

  function render() {
    if (state.step === 1) {
      content.innerHTML = progress(1) + '<p class="bm__eyebrow">Question 1 of 3</p><h2 class="bm__title" id="BeanitedBrewMatchTitle">How do you drink your coffee?</h2>' + options(["Milk", "Black", "Filter", "Decaf"], state.drink, "drink", false) + '<div class="bm__actions"><button class="bm__button" data-bm-next type="button">Next</button></div>' + browseLink();
    } else if (state.step === 2) {
      content.innerHTML = progress(2) + '<p class="bm__eyebrow">Question 2 of 3</p><h2 class="bm__title" id="BeanitedBrewMatchTitle">Preferred roast level?</h2>' + options(roastOptions, state.roast, "roast", false) + actions(false) + browseLink();
    } else if (state.step === 3) {
      content.innerHTML = progress(3) + '<p class="bm__eyebrow">Question 3 of 3</p><h2 class="bm__title" id="BeanitedBrewMatchTitle">Which profiles sound best?</h2><p class="bm__intro">Choose up to three.</p>' + options(profileOptions, state.profiles, "profiles", true) + '<div class="bm__actions"><button class="bm__button bm__button--secondary" data-bm-back type="button">Back</button><button class="bm__button" data-bm-results type="button">See my matches</button></div>' + browseLink();
    }
    wire();
  }

  function actions(back) {
    return '<div class="bm__actions">' + (back ? '<button class="bm__button bm__button--secondary" data-bm-back type="button">Back</button>' : "") + '<button class="bm__button" data-bm-next type="button">Next</button></div>';
  }

  function wire() {
    content.querySelectorAll("[data-bm-option]").forEach(function (button) {
      button.addEventListener("click", function () {
        var name = button.dataset.bmOption;
        var value = button.dataset.bmValue;
        if (name === "profiles") {
          var index = state.profiles.indexOf(value);
          if (index > -1) state.profiles.splice(index, 1);
          else if (state.profiles.length < 3) state.profiles.push(value);
        } else state[name] = value;
        render();
      });
    });
    var change = content.querySelector("[data-bm-step]");
    if (change) change.addEventListener("click", function () { state.step = 1; render(); });
    var back = content.querySelector("[data-bm-back]");
    if (back) back.addEventListener("click", function () { state.step = Math.max(1, state.step - 1); render(); });
    var next = content.querySelector("[data-bm-next]");
    if (next) next.addEventListener("click", function () {
      if ((state.step === 1 && !state.drink) || (state.step === 2 && !state.roast) || (state.step === 3 && !state.profiles.length)) return;
      state.step += 1;
      render();
    });
    var results = content.querySelector("[data-bm-results]");
    if (results) results.addEventListener("click", function () {
      var destination = resultsUrl();
      if (window.location.pathname !== destination.pathname) window.location.assign(destination.toString());
      else loadResults();
    });
  }

  function resultsUrl() {
    var url = new URL(coffeeUrl, window.location.origin);
    url.searchParams.set("bm_drink", state.drink || "");
    url.searchParams.set("bm_roast", state.roast || "");
    url.searchParams.set("bm_profiles", state.profiles.join("|"));
    return url;
  }

  function filterUrl() {
    var url = new URL(coffeeUrl, window.location.origin);
    if (state.drink === "Decaf") url.searchParams.append("filter.p.m.custom.product_attributes", "Decaf");
    else url.searchParams.append("filter.p.m.custom.beans_best_for", state.drink);
    if (state.roast) url.searchParams.append("filter.p.m.custom.roast_level", state.roast);
    state.profiles.forEach(function (profile) { url.searchParams.append("filter.p.m.custom.coffee_profile", profile); });
    return url;
  }

  async function loadResults() {
    content.innerHTML = '<h2 class="bm__title" id="BeanitedBrewMatchTitle">Finding your coffees</h2><p class="bm__status">Checking the Beanited coffee catalogue…</p>' + browseLink();
    if (productIndex.length) {
      renderResults(productIndex.filter(matchesState).sort(rankMatches).slice(0, 8));
      return;
    }
    try {
      var response = await fetch(filterUrl().toString(), { headers: { "X-Requested-With": "XMLHttpRequest" } });
      if (!response.ok) throw new Error("Coffee catalogue request failed");
      var documentCopy = new DOMParser().parseFromString(await response.text(), "text/html");
      var products = extractProducts(documentCopy);
      renderResults(products);
    } catch (error) {
      content.innerHTML = '<h2 class="bm__title" id="BeanitedBrewMatchTitle">We could not load your matches</h2><p class="bm__intro">Please try again or browse all coffees.</p>' + browseLink();
    }
  }

  function rankMatches(left, right) {
    var tierRank = { featured: 0, explore: 1, listed: 2 };
    var leftTier = tierRank[left.roasterTier] ?? 2;
    var rightTier = tierRank[right.roasterTier] ?? 2;
    if (leftTier !== rightTier) return leftTier - rightTier;
    if (left.roasterTier === "explore") return dateValue(right.roasterUpdatedAt) - dateValue(left.roasterUpdatedAt);
    if (left.roasterTier === "featured") return (Number(left.featuredPriority) || 9999) - (Number(right.featuredPriority) || 9999);
    return dateValue(left.createdAt) - dateValue(right.createdAt);
  }

  function dateValue(value) {
    var parsed = Date.parse(value || "");
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function matchesState(product) {
    var bestFor = Array.isArray(product.bestFor) ? product.bestFor : [];
    var attributes = Array.isArray(product.attributes) ? product.attributes : [];
    var profiles = Array.isArray(product.profiles) ? product.profiles : [];
    var drinkMatch = state.drink === "Decaf" ? attributes.indexOf("Decaf") > -1 : bestFor.indexOf(state.drink) > -1;
    var roastMatch = !state.roast || product.roast === state.roast;
    var profileMatch = !state.profiles.length || state.profiles.some(function (profile) { return profiles.indexOf(profile) > -1; });
    return drinkMatch && roastMatch && profileMatch;
  }

  function extractProducts(documentCopy) {
    var seen = {};
    return Array.from(documentCopy.querySelectorAll("#product-grid .grid__item")).map(function (card) {
      var link = card.querySelector(".card__heading a, a.full-unstyled-link");
      if (!link) return null;
      var href = link.getAttribute("href") || "";
      if (!href || seen[href]) return null;
      seen[href] = true;
      var image = card.querySelector("img");
      var price = card.querySelector(".price");
      var vendor = card.querySelector(".caption-with-letter-spacing");
      return { href: href, title: link.textContent.trim(), image: image ? (image.currentSrc || image.src) : "", price: price ? price.textContent.trim().replace(/\s+/g, " ") : "", vendor: vendor ? vendor.textContent.trim() : "" };
    }).filter(Boolean).slice(0, 8);
  }

  function renderResults(products) {
    var summary = [state.drink, state.roast, state.profiles.join(", ")].filter(Boolean).join(" · ");
    var cards = products.map(function (product) {
      var productUrl = product.href || product.url;
      return '<a class="bm__product" href="' + escapeHtml(productUrl) + '">' + (product.image ? '<img alt="" class="bm__product-image" src="' + escapeHtml(product.image) + '">' : '<span class="bm__product-image"></span>') + '<span class="bm__product-body">' + (product.vendor ? '<span class="bm__product-vendor">' + escapeHtml(product.vendor) + '</span>' : "") + '<strong class="bm__product-title">' + escapeHtml(product.title) + '</strong><span class="bm__product-price">' + escapeHtml(product.price) + '</span></span></a>';
    }).join("");
    content.innerHTML = '<p class="bm__eyebrow">Your matches</p><h2 class="bm__title" id="BeanitedBrewMatchTitle">Coffees picked for you</h2><p class="bm__intro">' + escapeHtml(summary) + '</p>' + (cards ? '<div class="bm__results">' + cards + '</div>' : '<p class="bm__status">No exact matches yet. Try changing one answer or browse all coffees.</p>') + browseLink();
  }

  function open(drink) {
    previousFocus = document.activeElement;
    state = { drink: drink, roast: null, profiles: [], step: 2 };
    root.hidden = false;
    document.body.style.overflow = "hidden";
    render();
    root.querySelector(".beanited-brew-match__close").focus();
  }

  function close() {
    root.hidden = true;
    document.body.style.overflow = "";
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  function restoreResults() {
    var params = new URLSearchParams(window.location.search);
    var drink = params.get("bm_drink");
    var roast = params.get("bm_roast");
    var profiles = (params.get("bm_profiles") || "").split("|").filter(Boolean);
    if (!enabled || !drink || !roast || !profiles.length || !productIndex.length) return;
    state = { drink: drink, roast: roast, profiles: profiles, step: 3 };
    root.hidden = false;
    document.body.style.overflow = "hidden";
    loadResults();
  }

  root.querySelectorAll("[data-bm-close]").forEach(function (button) { button.addEventListener("click", close); });
  document.addEventListener("keydown", function (event) { if (!root.hidden && event.key === "Escape") close(); });

  window.addEventListener("click", function (event) {
    var item = event.target.closest && event.target.closest(".bhr-drink__item");
    if (!item) return;
    var label = item.querySelector(".bhr-drink__label");
    var drink = drinkMap[(label ? label.textContent : "").trim().toLowerCase()];
    if (!drink) return;
    if (!enabled) return;
    event.stopImmediatePropagation();
    event.preventDefault();
    open(drink);
  }, true);

  restoreResults();
})();
